// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {getAlertBarClass} from './services/alert-bar-class';

const InlineAlertBar = props =>
    <div
        className={getAlertBarClass(props.type)}
    >
        <FormattedMessage
            id={props.label}
        />
    </div>;

InlineAlertBar.displayName = 'InlineAlertBar';
InlineAlertBar.propTypes = {
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
};
InlineAlertBar.defaultProps = {
    type: 'info'
};
export default InlineAlertBar;



// WEBPACK FOOTER //
// ./src/shared/components/inline-alert-bar/index.js